import React, { useRef, useState } from "react";
import "./PnLFilterBar.scss";
import { useHistory } from "react-router-dom";
import { CompareIcon } from "../PnLFloorplanDetails/PnLFloorplanIconsSvg";
import SearchIcon from "../SearchIcon/SearchIcon";
import { filterFloorplans, updateBedroomFilterValue, updateProductFilterValue, updateSearchFilterValue, updateSizeFilterValue } from "../../redux/actions/floorplanActions";
import { useDispatch, useSelector } from "react-redux";
import SquareFootIcon from "../SquareFootIcon/SquareFootIcon";
import DownArrowIcon from "../DownArrowIcon/DownArrowIcon";
import BedroomsIcon from "../BedroomsIcon/BedroomsIcon";
import Hamburger from "../Hamburger/Hamburger";
import VirtualKeyboard from "../VirtualKeyboard/VirtualKeyboard";
import { useEffect } from "react";

function FilterArrow() {

    return (
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.47314 0.656738L5.47314 5.34305" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9.47314 0.656738L5.47314 5.34305" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

function LotFilterRadio(props) {
    var classes = "LotFilterRadio";
    if(props.selected) classes += " selected";

    function handleClick(index, value) {
        props.callback(index, value);
    }

    return (
        <button
            className={classes}
            onClick={() => handleClick(props.index, props.value)}
        >
            <div className="circle"></div>
            <div className="label">{props.label} Lots</div>
        </button>
    )
}

function PnLFilterDropdown(props) {
    var container = useRef();
    var classes = "PnLFilterDropdown";
    var height = 0;
    var [open, setOpen] = useState(false);

    if(open) {
        classes += " open";
        if(container.current) {
            height = container.current.scrollHeight;
        }
    }
    
    return (
        <div
            className={classes}
        >
            <div className="mobile-wrapper-container">
                <div className="filter-label" onClick={() => setOpen(!open)}>
                    {props.icon}
                    <div className="label">
                        {
                            props.activeFilterIndex != -1 ? 
                            props.options[props.activeFilterIndex].label :
                            props.defaultLabel
                        }
                        <FilterArrow />
                    </div>
                </div>
                <div className="options-wrapper" ref={container} style={{height: height}}>
                    <div className="options-container">
                        <button className={`option ${props.activeFilterIndex == -1 ? " selected" : ""}`} onClick={() => props.callback(-1, "all")}>
                            <div className="square"></div> <div className="label">View All</div>
                        </button>
                        {props.options && props.options.map((option, okey) => {
                            var optionClasses = "option";
                            if(props.activeFilterIndex == okey) optionClasses += " selected";
                            return (
                                <button className={optionClasses} onClick={() => props.callback(okey, option.value)}>
                                    <div className="square"></div> <div className="label">{option.label}</div>
                                </button>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

function PnLFilterBar(props) {
    var dispatch = useDispatch();
    var history = useHistory();
    var searchInput = useRef();
    var products = useSelector(state => state.floorplan.products);
    var productFilterID = useSelector(state => state.floorplan.productFilterID);
    var [mobileOpen, setMobileOpen] = useState(false);
    var mobileMenuContainerclasses = "mobile-menu-container";
    if(mobileOpen) mobileMenuContainerclasses += " open";
    var isTouchScreen = useSelector(state => state.utilities.isTouchScreen);
    var [input, setInput] = useState('');
    var keyboard = useRef();
    const [keyboardOpen, setKeyboardOpen] = useState(false)

    //size
    var sizeFilterID = useSelector(state => state.floorplan.sizeFilterID);
    var sizes = [
        {
            value: "1500",
            label: "1500+ SQ. FT"
        },
        {
            value: "2000",
            label: "2000+ SQ. FT"
        },
        {
            value: "2250",
            label: "2250+ SQ. FT"
        },
        {
            value: "2500",
            label: "2500+ SQ. FT"
        }
    ];

    var bedroomFilterID = useSelector(state => state.floorplan.bedroomFilterID);
    var bedroomSizes = [
        {
            value: "3",
            label: "3 Bedrooms"
        },
        {
            value: "4",
            label: "4 Bedrooms"
        },
        {
            value: "5",
            label: "5 Bedrooms"
        }
    ];

    function runQuickFloorplanSearch(value) {
        //use the value to have redux run a search filter. its time to add in the filter
        dispatch(updateSearchFilterValue(value));
        dispatch(filterFloorplans());
    }

    function onChange(input) {
        setInput(input);
        runQuickFloorplanSearch(input);
    }

    function onInputChange(e) {
        var i = e.target.value;
        setInput(i);
        keyboard.current.setInput(i);
        runQuickFloorplanSearch(i);
    }

    function openKeyboard() {
        setKeyboardOpen(true);
    }

    function close(e) {
        if (
            !e.target.closest('#floorplan-search') &&
            !e.target.closest('.virtual-keyboard')
        ) {
            setKeyboardOpen(false);
        }
    }

    function updateProductLot(index, value) {
        dispatch(updateProductFilterValue(index, value));
        dispatch(filterFloorplans());
    }

    function changeSelectedBedroomFilterValue(index, value) {
        dispatch(updateBedroomFilterValue(index, value));
        dispatch(filterFloorplans());
    }

    function updateFilteredSize(index, value) {
        if(index !== sizeFilterID) {
            dispatch(updateSizeFilterValue(index, value));
            dispatch(filterFloorplans());
        }
    }

    function toggleMobileMenu() {
        setMobileOpen(!mobileOpen);
    }
    
    useEffect(() => {
        document.addEventListener('click', close);
        return () => {
            document.removeEventListener('click', close);
        };
    });

    return (
        <div className={`PnLFilterBar${isTouchScreen ? " touchscreen" : ""}`}>
            <div className={mobileMenuContainerclasses}>
                <div className="filters-container">
                    <div className="search-container">
                        <SearchIcon />
                        <input
                            type="text"
                            id="floorplan-search-bar"
                            placeholder="search floorplan"
                            onChange={(e) => 
                                runQuickFloorplanSearch(e.target.value)
                            }
                            ref={searchInput}
                        />
                    </div>
                    <div className="lot-filter">
                        <LotFilterRadio
                            value="all"
                            label="All"
                            index={-1}
                            selected={productFilterID == -1}
                            callback={updateProductLot}
                        />
                        {products && products.map((product, pkey) => 
                            <LotFilterRadio
                                value={product.term_id}
                                label={product.name}
                                index={pkey}
                                selected={pkey == productFilterID}
                                callback={updateProductLot}
                            />
                        )}
                    </div>
                    <div className="size-filter bedroom">
                        <PnLFilterDropdown
                            options={bedroomSizes}
                            defaultLabel="Bedroom"
                            callback={changeSelectedBedroomFilterValue}
                            activeFilterIndex={bedroomFilterID}
                            icon={<BedroomsIcon />}
                        />
                    </div> 
                    <div className="size-filter">
                        <PnLFilterDropdown
                            options={sizes}
                            defaultLabel="SQ. FT."
                            callback={updateFilteredSize}
                            activeFilterIndex={sizeFilterID}
                            icon={<SquareFootIcon />}
                        />
                    </div>
                </div> 
            </div>
                <div className="search-container">
                    <SearchIcon />
                    {!isTouchScreen && (
                        <input
                            type="text"
                            id="floorplan-search-bar"
                            placeholder="search floorplan"
                            onChange={(e) => 
                                runQuickFloorplanSearch(e.target.value)
                            }
                            ref={searchInput}
                        />
                    )}
                    {isTouchScreen && (
                        <input
                            type="text"
                            id="floorplan-search"
                            placeholder="Search floorplan"
                            onChange={onInputChange}
                            value={input}
                            ref={searchInput}
                            onClick={openKeyboard}
                        />
                    )}
                    {isTouchScreen && (
                        <VirtualKeyboard
                            keyboard={keyboard}
                            onChange={onChange}
                            open={keyboardOpen}
                        />
                    )}
                </div>
                <div className="filters-container">
                    <div className="lot-filter">
                        <LotFilterRadio
                            value="all"
                            label="All"
                            index={-1}
                            selected={productFilterID == -1}
                            callback={updateProductLot}
                        />
                        {products && products.map((product, pkey) => 
                            <LotFilterRadio
                                value={product.term_id}
                                label={product.name}
                                index={pkey}
                                selected={pkey == productFilterID}
                                callback={updateProductLot}
                            />
                        )}
                    </div>
                    <div className="size-filter bedroom">
                        <PnLFilterDropdown
                            options={bedroomSizes}
                            defaultLabel="Bedroom"
                            callback={changeSelectedBedroomFilterValue}
                            activeFilterIndex={bedroomFilterID}
                            icon={<BedroomsIcon />}
                        />
                    </div> 
                    <div className="size-filter">
                        <PnLFilterDropdown
                            options={sizes}
                            defaultLabel="SQ. FT."
                            callback={updateFilteredSize}
                            activeFilterIndex={sizeFilterID}
                            icon={<SquareFootIcon />}
                        />
                    </div>
                </div>
                <button
                    className="compare-link"
                    onClick={() => history.push("/floorplans/compare")}
                >
                    <CompareIcon /> <span>Compare Floorplans</span>
                </button>
                <div className="filter-label">
                    Filters
                </div>
                <div className="hamburger-container" onClick={toggleMobileMenu}>
                    <Hamburger active={mobileOpen} />
                </div>
        </div>
    )
}

export default PnLFilterBar;